var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"berkah1000",domProps:{"innerHTML":_vm._s(_vm.content)}}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('img',{attrs:{"src":"/img/footersss.svg"}})])
}]

export { render, staticRenderFns }